angular.module('project')
    .component('projectPickerMultiple', {
        require: {
            ngModelCtrl: "^ngModel"
        },
        bindings: {
            ngModel: '=',
            userProjectsFilter: '=',
            required: "=",
            modelType: '<',
            salesTeamConfiguration: '<',
            onChange: "&"
        },
        templateUrl: "app/project/picker/picker-multiple.html",
        controllerAs: 'ctrl',
        controller: function ($scope, $element, $attrs, Project, uiSelectFix) {
            let ctrl = this
            ctrl.uiSelectFix = uiSelectFix

            ctrl.$onInit = () => {
                ctrl.modelTypeR = ctrl.modelType || "object"
                ctrl.currentUserOnly = ctrl.userProjectsFilter || false
                const params = {userProjectsFilter: ctrl.userProjectsFilter}
                const request = ctrl.salesTeamConfiguration ? Project.salesTeamAutocomplete(params).$promise : Project.autocomplete(params).$promise
                request.then(items => {
                    ctrl.items = formatAndMap(items)
                })
            }

            ctrl.$onChanges = () => { //changes from parent controller
                ctrl.selected = formatAndMap(ctrl.ngModel)
                ctrl.ngChange()
            }
            ctrl.ngChange = () => ctrl.ngModel = ctrl.selected

            function formatAndMap(items) {
                if (!angular.isArray(items)) {
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        }
    })
